import noop from '@picsart/rc/noop';

import { RegistrationModal } from '@picsart/growth-rc/Registration';
import type { AuthModalType } from './types';

function AuthModal({ successHandler = noop, closeHandler, isOpen }: AuthModalType) {
  return (
    <RegistrationModal
      triggeredFrom="cta"
      isOpen={isOpen}
      onModalStateChange={closeHandler}
      authSuccessHandler={user => successHandler(user)}
    />
  );
}
export default AuthModal;
